/**
 * @packageDocumentation
 * @module      UserDetails.ts
 * @description Encapsulates data about a user.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
/**
 * Encapsulates data about a user.
 */
export default class UserDetails {
    constructor() {
        /** The primary key for this user, or null for a user that has not been saved yet.. */
        this.userId = null;
        /** The username (e.g., JDoe). */
        this.username = "";
        /**
         * The password, not encrypted if creating a new user, or null if coming from the server.
         */
        this.password = null;
        /** The user's first name */
        this.firstName = "";
        /** The user's last name */
        this.lastName = "";
        this.roles = [];
    }
    hasRole(roleName) {
        return this.roles.some((r) => r.roleName === roleName);
    }
    setRole(roleName, grant) {
        if (grant) {
            if (!this.hasRole(roleName)) {
                this.roles.push(new Role(roleName));
            }
        }
        else {
            const ix = this.roles.findIndex((r) => r.roleName == roleName);
            if (ix >= 0) {
                this.roles.splice(ix, 1);
            }
        }
    }
    /**
     *  The systemId for a user's dedicated system is not part of this class. If the user
     *  is a dedicated device principal, the SystemController (on the server) will fill in the
     *  systemId when creating or updating the user. Such user maintenance for device principals
     *  must therefore be done through the SystemController. Adding or deleting human principals
     *  can be done by calling the UserController's methods.
     */
    /**
     * Return the "LastName, FirstName" or just one or the other if that's all we have, or ''.
     */
    getLastCommaFirst() {
        let lastCommaFirst = this.lastName || '';
        if (this.lastName && this.firstName) {
            lastCommaFirst += ', ';
        }
        lastCommaFirst += (this.firstName || '');
        return lastCommaFirst.trim();
    }
    toJSON() {
        return Object.assign({}, this);
    }
    static fromJSON(json) {
        let user = new UserDetails();
        const jsonKeys = Object.getOwnPropertyNames(json);
        jsonKeys.forEach((key) => {
            if (!user.hasOwnProperty(key)) {
                delete json[key];
            }
        });
        Object.assign(user, json);
        if (!user.roles) {
            user.roles = [];
        }
        return user;
    }
}
export class Role {
    constructor(roleName) {
        this.roleName = '';
        this.roleName = roleName;
    }
}
export var RoleName;
(function (RoleName) {
    RoleName["UserAdmin"] = "ADMIN";
    RoleName["SystemAdmin"] = "WEB";
    RoleName["API"] = "API";
})(RoleName || (RoleName = {}));
//# sourceMappingURL=UserDetails.js.map